import { Card, Typography } from '@material-ui/core';
import React from 'react';
import { useStyle } from './summary.style';

export const Summary = ({ children, title }) => {
    const classes = useStyle();

    return (
        <Card className={classes.container}>
            <Typography className={classes.headline} variant="h5" color="textSecondary">
                {title}
            </Typography>
            <div className={classes.content}>
                <ul>{children}</ul>
            </div>
        </Card>
    );
};
